import { Box, Flex } from '@myphx-engineering/phx-design-system';
import { useIsMobile } from '@myphx-engineering/phx-design-system/hooks';

import type { PathwayOptionConfig } from '../../../configuration/shared';

import { PathwayOptionCard } from './configurable-path-selection/PathwayOptionCard';

interface Props {
    options: PathwayOptionConfig[];
}

export const ConfigurablePathSelectionCards = ({ options }: Props) => {
    const isMobile = useIsMobile('sm');

    return (
        <Flex gap="xs" style={{ flexDirection: isMobile ? 'column' : 'row' }}>
            {options.map((option) => (
                <Box key={option.id} flex={1}>
                    <PathwayOptionCard option={option} />
                </Box>
            ))}
        </Flex>
    );
};
